/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'react',
	'prop-types'
], (React, PropTypes) => {

	return class GridDropTarget extends React.Component {
		static propTypes = {
			dndManager: PropTypes.any
		}
		constructor(props) {
			super(props);
			this.ref = React.createRef();
		}
		componentDidMount() {
			this.props.dndManager.registerElement(this, this.ref.current);
		}

		componentWillUnmount() {
			this.props.dndManager.deregisterElement(this.ref.current);
		}

		render() {
			const props = { ...this.props };
			delete props.dndManager;
			return(<div ref={this.ref} {...props}/>);
		}
	};
});